import {O} from "web-vcore";
import {UsersState} from "./users.js";

export class MoreState {
	@O accessor subpage = "users";
	@O accessor users = new UsersState();
	@O accessor feedback = {} as {subpage: string};
}